import {atom} from "recoil";

export const unidadesState = atom({
  key: 'unidadesState',
  default: []
});
